import {html} from "./utils/environment";

import accordion from "./components/accordion";
import detailsFilters from "./components/details-filters";
import header from "./components/header";
import homeBrands from "./components/home-brands";
import inputswitch from "./components/switch";
import modal from "./components/modal.js";
import productsFilters from "./components/products-filters.js";
import rrp from "./components/rrp.js";
import scrolltotop from "./components/scrolltotop";
import sidebar from "./components/sidebar";
import stores from "./components/stores.js";
import swiperhome from "./components/swiper-home";
import swiperproductarchive from "./components/swiper-productarchive";
import swiperproductsingle from "./components/swiper-productsingle";
import tabs from "./components/tabs";

import hmkmailchimp from "./components/hmk/mailchimp";
import hmkmain from "./components/hmk/main";
import hmkminicart from "./components/hmk/minicart";

window.addEventListener('DOMContentLoaded', init);

function init() {
    // console.log("App JS Started");

    html.classList.add("is-loaded");
    html.classList.add("is-ready");
    html.classList.remove("is-loading");

    accordion();
    detailsFilters();
    header();
    homeBrands();
    inputswitch();
    modal();
    productsFilters();
    rrp();
    scrolltotop();
    sidebar();
    stores();
    swiperhome();
    swiperproductarchive();
    swiperproductsingle();
    tabs();
    
    hmkmain();
    hmkminicart();
    if (document.getElementById("mc-embedded-subscribe-form")){
        hmkmailchimp();
    }

    // Gestisce lo scroll top dei pannelli in accordion nella scheda prodotto
    document.getElementById("esf")?.addEventListener("after_open", event => {
        // @link https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
        event.detail?.item?.scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth"
        });
    });
}
